import { TRAIL_DASHBOARD_USER_PREF, PRIVILEGE_DASHBOARD_USER_PREF } from './user-pref.type'

// prettier-ignore
const state = {
  trailsDashboardUserSetting:
    localStorage.getItem('trail_dashboard_view_preferences') &&
    JSON.parse(localStorage.getItem('trail_dashboard_view_preferences'))
      ? JSON.parse(localStorage.getItem('trail_dashboard_view_preferences'))
      : { orderBy: 'desc_score' },
  privilegeDashboardUserSetting:
    localStorage.getItem('privilege_dashboard_view_preferences') &&
    JSON.parse(localStorage.getItem('privilege_dashboard_view_preferences'))
      ? JSON.parse(localStorage.getItem('privilege_dashboard_view_preferences'))
      : { orderBy: 'desc_datetime' }
}

const getters = {
  trailsDashboardUserSetting: state => state.trailsDashboardUserSetting,
  privilegeDashboardUserSetting: state => state.privilegeDashboardUserSetting
}

const mutations = {
  [TRAIL_DASHBOARD_USER_PREF]: (state, pref) => {
    state.trailsDashboardUserSetting = _.merge(state.trailsDashboardUserSetting, pref)
    localStorage.setItem('trail_dashboard_view_preferences', JSON.stringify(state.trailsDashboardUserSetting))
  },
  [PRIVILEGE_DASHBOARD_USER_PREF]: (state, pref) => {
    state.privilegeDashboardUserSetting = _.merge(state.privilegeDashboardUserSetting, pref)
    localStorage.setItem('privilege_dashboard_view_preferences', JSON.stringify(state.privilegeDashboardUserSetting))
  }
}

const actions = {
  [TRAIL_DASHBOARD_USER_PREF] (context, viewPref) {
    context.commit(TRAIL_DASHBOARD_USER_PREF, viewPref)
  },
  [PRIVILEGE_DASHBOARD_USER_PREF] (context, viewPref) {
    context.commit(PRIVILEGE_DASHBOARD_USER_PREF, viewPref)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user_pref/user-pref.module.js